/**
 * Components index file
 * Exports all components from the components directory
 */

// Import component groups
import * as common from './common';
import * as forms from './forms';
import * as lists from './lists';
import * as management from './management';
import * as pages from './pages';
import * as hooks from './hooks';
import * as slices from './slices';
import * as styles from './styles';
import * as utils from './utils';

// Export component groups
export {
  common,
  forms,
  lists,
  management,
  pages,
  hooks,
  slices,
  styles,
  utils
};

// Export individual components for convenience
export const {
  StatusDisplay,
  StatusEditor,
  EntityCard
} = common;

export const {
  LitGroupProfileForm,
  BookForm,
  CharacterForm,
  VariationForm
} = forms;

export const {
  VariationsList,
  LitGroupsListEnh,
  BooksListEnh,
  CharactersListEnh
} = lists;

export const {
  VariationManagement,
  LitGroupManagementEnh,
  BookManagementEnh,
  CharacterManagementEnh
} = management;

export const {
  BookWorksheetPageEnh,
  BookWorksheetPageWrapperEnh
} = pages;

export const {
  useStatusManagement,
  useFormManagement
} = hooks;

export const {
  formatComponentName,
  generateComponentId
} = utils;

// Export default
export default {
  common,
  forms,
  lists,
  management,
  pages,
  hooks,
  slices,
  styles,
  utils
};
